import type { AutocompleteListItem } from "models/propTypes/listPropTypes";

interface CustomerServices {
  /** The company's top customers (GetTopCustomers). */
  getCustomerSuggestions: () => Promise<{ id?: number; name?: string }[]>;
  /** The app's customer search by name (GetSearchCustomersByName), already mapped to options. */
  searchCustomers: (text: string) => Promise<AutocompleteListItem[]> | AutocompleteListItem[];
}

/** The customer field's search and suggestions, on the same customer endpoints as the invoice form. */
export function createCostForwardingCustomerSources(
  services: CustomerServices,
  suggestion: Pick<AutocompleteListItem, "icon" | "group">
) {
  const loadSuggestions = (): Promise<AutocompleteListItem[]> =>
    services
      .getCustomerSuggestions()
      .then((customers) =>
        (customers ?? []).map((customer) => ({
          id: customer.id ?? 0,
          value: customer.name ?? "",
          icon: suggestion.icon,
          group: suggestion.group,
        }))
      )
      .catch(() => []);

  return { loadSuggestions, search: services.searchCustomers };
}
